import { c as _c } from "react/compiler-runtime";
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useRouter } from 'next/router';
type RouterQuery = {
  step?: string;
  tab?: FunnelStepSettingTabsEnum;
  funnelId?: string;
  [key: string]: string | string[] | undefined;
};
export function useUpdateFunnelStepQuery() {
  const $ = _c(9);
  const router = useRouter();
  const query = router.query as RouterQuery;
  let t0;
  if ($[0] !== query || $[1] !== router) {
    t0 = (funnelStepId, funnelStepTab) => {
      if (!router.isReady) {
        return;
      }
      const currentStep = query.step ? Number(query.step) : null;
      if (currentStep === funnelStepId && (!funnelStepTab || query.tab === funnelStepTab)) {
        return;
      }
      const newQuery = {
        ...query,
        step: String(funnelStepId),
        ...(funnelStepTab && {
          tab: funnelStepTab
        })
      };
      router.replace({
        pathname: router.pathname,
        query: newQuery
      }, undefined, {
        shallow: true
      }).catch(_temp);
    };
    $[0] = query;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const updateFunnelStepQuery = t0;
  let t1;
  if ($[3] !== query || $[4] !== updateFunnelStepQuery) {
    t1 = () => {
      if (!query.step) {
        return;
      }
      updateFunnelStepQuery(Number(query.step));
    };
    $[3] = query;
    $[4] = updateFunnelStepQuery;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const clearFunnelStepTabQuery = t1;
  let t2;
  if ($[6] !== clearFunnelStepTabQuery || $[7] !== updateFunnelStepQuery) {
    t2 = {
      updateFunnelStepQuery,
      clearFunnelStepTabQuery
    };
    $[6] = clearFunnelStepTabQuery;
    $[7] = updateFunnelStepQuery;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(e) {
  if (!e.cancelled) {
    console.error(e);
  }
}